import { createSelector } from "reselect";
import { ApprovalI } from "../approvals/approvalsTypes";
import { AppState } from "../store";
import { RealTimeDataReducer } from "./types";

export const filterByStatus = (approvals: Array<ApprovalI>, section: "queue" | "history") => {
  const data = approvals.filter((approval: ApprovalI) => approval.section === section);
  const size = data.length;

  return [ ...data.slice(size > 3 ? size - 4 : 0) ];
};

const selector = (state: AppState) => state.realTimeDataReducer;

export const approvalQueue = createSelector([ selector ], ({ approvalsStack }) => filterByStatus(approvalsStack, "queue"));

export const approvalHistory = createSelector([ selector ], ({ approvalsStack }) =>
  filterByStatus(approvalsStack, "history"));

export const realTimeDataSectionSelector = createSelector([ selector ], (state: RealTimeDataReducer) => state.section);
